import React, { useCallback, useState } from "react";
import { getClassRequest } from "../../services/userServices";
import AsttCard from "../ASTT Card/asttCard";
import AsttButton from "../AsttButton/AsttButton";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import CloseIcon from "@mui/icons-material/Close";
import classes from "./ParentClientCard.module.css";
import moment from "moment";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import WaveRosterComponent from "../WaveRosterDetails/WaveRosterDetails";
import ClassRequest from "../../components/ClassRequestDrawer/ClassRequestDrawer";
import ClassRequestEdit from "../../components/ClassRequestEdit/ClassRequestEdit";
import { useDispatch, useSelector } from "react-redux";
import { classRequestActions } from "../../Store/ClassRequest";
import { generalStoreActions } from "../../Store/GeneralStore";
import FileAttachmentDrawer from "components/FileAttachmentDrawer/FileAttachmentDrawer";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
// Table import
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import AsttDarkButton from "../ASTTButtonDark/AsttButtonDark";
import AsttLightButton from "../ASTTButtonLight/AsttButtonLight";

import BackdropComponent from "../Spinner/Spinner";
// Drawer import
import Drawer from "@mui/material/Drawer";
import { Chip, Dialog, IconButton, Typography } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import { CustomTooltip } from "components/RosterConfig/RosterConfigStyle";
import pillThemeConfig from "styles/pillThemeConfig";

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxHeight: 500,
    overflow: "scroll",
  },
});

const ParentClientCard = (props) => {
  const { t } = useTranslation(["parentclientcard"]);

  const generalStore = useSelector((state) => state.generalStore);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [classRequest, setClassRequest] = useState([]);
  const [classRequestId, setClassRequestId] = useState("");
  const [request, setrequest] = useState("");
  const [showClassRequest, setShowClassRequest] = useState(false);
  const [classRequestFileAttachment, setClassRequestFileAttachment] = useState(
    [],
  );
  const [drawerType, setDrawerType] = useState("view");

  const [loading, setLoading] = useState(false);
  const ItemHeading = styled(Paper)(() => ({
    textAlign: "center",
    boxShadow: "none",
    fontWeight: 700,
  }));
  const ItemStaring = styled(Paper)(() => ({
    textAlign: "start",
    boxShadow: "none",
    fontWeight: 700,
  }));
  const Item = styled(Paper)(() => ({
    textAlign: "center",
    boxShadow: "none",
  }));

  const [attachmentState, setAttachmentState] = React.useState({
    right: false,
  });

  const navigateToRoster = (id, data) => {
    dispatch(generalStoreActions.updateClassRequestId(id));
    dispatch(generalStoreActions.updateClassRequestButton(false));
    dispatch(generalStoreActions.updateProgramName(data.program));
    const path = `/rosterSearch/${id}/null`;
    navigate(path);
  };

  const classRequestDetails = async (event) => {
    setLoading(true);
    const data = await getClassRequest(event.classRequestId);
    if (data.status === true) {
      setLoading(false);
      setClassRequestId(event.classRequestId);
      setClassRequest([data.data.classRequestDetail]);
      setClassRequestFileAttachment(data.data.classFileAttachmentDetails);
      setShowClassRequest(true);
    } else {
      setLoading(false);
    }
  };

  const hideClassRequestHandler = () => {
    setShowClassRequest(false);
    setClassRequest([]);
  };

  const columns = [
    {
      id: "pc",
      label: t("ProductionClassification"),
      align: "center",
    },
    {
      id: "nc",
      label: t("NoOfClasses"),
      align: "center",
    },
    {
      id: "gpm",
      label: t("GPMPOC"),
      align: "center",
    },
    {
      id: "cfg",
      label: t("ClassFillGoal"),
      align: "center",
    },
    {
      id: "ct",
      label: t("ClassType"),
      align: "center",
    },
    {
      id: "pfg",
      label: t("ProductFillGoal"),
      align: "center",
    },
    {
      id: "tc",
      label: t("TrainingClassification"),
      align: "center",
    },
    {
      id: "rs",
      label: t("RequestStatus"),
      align: "center",
    },
  ];
  const [state, setState] = React.useState({
    right: false,
  });

  const drawerFileAttachment = (anchor, open, data) => (event) => {
    setrequest(data);
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    if (open === false) {
      hideClassRequestHandler();
    }
    setAttachmentState({ ...state, [anchor]: open });
  };

  const toggleDrawer = (anchor, open, type) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    type = type || drawerType;
    setDrawerType(type);
    dispatch(classRequestActions.addClassRequest(classRequest[0]));
    toggleDrawer("right", true, "edit");
    dispatch(generalStoreActions.updateShowProject(false));
    setState({ ...state, [anchor]: open });
    if (open === false) {
      hideClassRequestHandler();
      dispatch(generalStoreActions.updateClassRequestCreated(true));
    }
  };

  const showEditHandler = () => {
    setDrawerType("edit");
  };

  const handleReset = useCallback(async (classRequestId) => {
    const data = await getClassRequest(classRequestId);
    if (data.status === true) {
      setLoading(false);
      dispatch(classRequestActions.resetHandlerFunction(true));
      dispatch(
        classRequestActions.addClassRequest(data.data.classRequestDetail),
      );
    } else {
      setLoading(false);
    }
  }, []);

  const prepareChipStyle = (label) => ({
    fontWeight: "bold",
    backgroundColor: pillThemeConfig[label]?.primaryColor,
    color: pillThemeConfig[label]?.fontColor,
    maxWidth: "100px",
    fontSize: "15px",
    position: "relative",
  });

  return (
    <div>
      {loading ? <BackdropComponent /> : null}
      {props.parentClientData.map((data, i) => (
        <div key={i}>
          <AsttCard parentClientStyle={{ padding: 20 }}>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <ItemStaring>{t("program")}</ItemStaring>
              </Grid>
              <Grid item xs={3}>
                <ItemHeading>{t("wave")} #</ItemHeading>
              </Grid>
              <Grid item xs={3}>
                <ItemHeading>{t("rosterlockdate")}</ItemHeading>
              </Grid>
            </Grid>
            <Grid className={classes.mtgrid} container spacing={2}>
              <Grid item xs={4}>
                <CustomWidthTooltip
                  title={data.program}
                  arrow
                  placement="right-end"
                >
                  <div
                    className={`${classes.programContent}+ " " + ${classes.mt10px} + ' ' + ${classes.height15} ${classes.programOverflow}`}
                  >
                    {data.program}
                  </div>
                </CustomWidthTooltip>

                <CustomWidthTooltip
                  title={data.project}
                  arrow
                  placement="right-start"
                >
                  <div
                    className={`${classes.programContent}+ " " + ${classes.mt10px} + ' ' + ${classes.height15} ${classes.programOverflow}`}
                  >
                    {data.project}
                  </div>
                </CustomWidthTooltip>

                <p className={classes.programContent + " " + classes.mt10px}>
                  {data.siteLocation}
                </p>
                <p className={classes.mt10px}>
                  <span className={classes.headingParent}>Rosters </span> ({" "}
                  <span className={classes.blueColor}>
                    {" "}
                    Active / FTRR / E2P{" "}
                  </span>
                  ):
                </p>
              </Grid>
              <Grid item xs={3}>
                <Item className={classes.headingParent + " " + classes.mt10px}>
                  {data.wave}
                </Item>
              </Grid>
              <Grid item xs={3}>
                <Item className={classes.headingParent + " " + classes.mt10px}>
                  {data.rosterLockDate !== "" &&
                    moment(data.rosterLockDate).format("YYYY-MM-DD")}
                </Item>
                <Item className={classes.headingParent + " " + classes.mt10px}>
                  {data.rosterLockTimestamp !== "" && (
                    <p>
                      Entered:{" "}
                      {moment
                        .utc(data.rosterLockTimestamp)
                        .format("YYYY-MM-DD  hh:mm:ss A")}
                    </p>
                  )}
                </Item>
              </Grid>
              <Grid className={"text-center"} item xs={2}>
                {!showClassRequest &&
                  data.classRequestId === classRequestId && (
                    <KeyboardArrowDownIcon
                      onClick={() => classRequestDetails(data)}
                      className={"fs-icon cursor-pointer"}
                    ></KeyboardArrowDownIcon>
                  )}
                {data.classRequestId === classRequestId && showClassRequest && (
                  <KeyboardArrowUpIcon
                    onClick={hideClassRequestHandler}
                    className={"fs-icon cursor-pointer orangeColor"}
                  ></KeyboardArrowUpIcon>
                )}
                {data.classRequestId !== classRequestId && (
                  <KeyboardArrowDownIcon
                    onClick={() => classRequestDetails(data)}
                    className={"fs-icon cursor-pointer"}
                  ></KeyboardArrowDownIcon>
                )}
              </Grid>
            </Grid>
            {data.waveRoster ? (
              <WaveRosterComponent waveRoster={data.waveRoster} />
            ) : null}
          </AsttCard>
          {data.classRequestId === classRequestId &&
            classRequest.length > 0 && (
              <div className={"background-white"}>
                <TableContainer sx={{ width: "100%", overflow: "hidden" }}>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {columns.map((column, i) => (
                          <TableCell key={i} align={column.align}>
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {classRequest.map((row, i) => (
                        <TableRow
                          key={i}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell
                            className={classes.tableData}
                            align="center"
                          >
                            {row.productionClassification}
                          </TableCell>
                          <TableCell
                            className={classes.tableData}
                            align="center"
                          >
                            {row.numberOfClasses}
                          </TableCell>
                          <TableCell
                            className={classes.tableData}
                            align="center"
                          >
                            {row.gpmpoc}
                          </TableCell>
                          <TableCell
                            className={classes.tableData}
                            align="center"
                          >
                            {row.classFillGoal}
                          </TableCell>
                          <TableCell
                            className={classes.tableData}
                            align="center"
                          >
                            {row.classType}
                          </TableCell>
                          <TableCell
                            className={classes.tableData}
                            align="center"
                          >
                            {row.productionFillGoal}
                          </TableCell>
                          <TableCell
                            className={classes.tableData}
                            align="center"
                          >
                            {row.trainingClassification}
                          </TableCell>
                          <TableCell
                            className={classes.tableData}
                            align="center"
                          >
                            {" "}
                            {row.requestStatus}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Grid className={"align-center"} container spacing={2}>
                  <Grid className={"text-center"} item xs={2}>
                    <UploadFileIcon
                      onClick={drawerFileAttachment(
                        "right",
                        true,
                        classRequest[0],
                      )}
                      className={"fs-icon-class"}
                    ></UploadFileIcon>
                  </Grid>
                  <Grid item xs={2}>
                    {classRequestFileAttachment.length > 0 && (
                      <p>Hiring Bands</p>
                    )}
                  </Grid>
                  <Grid item xs={1}>
                    <p className="orangeColor">
                      {classRequestFileAttachment.length} files
                    </p>
                  </Grid>
                  <Grid className={"text-center"} item xs={3}>
                    <AsttDarkButton
                      onClick={toggleDrawer("right", true, "view")}
                    >
                      {t("classRequestDetails")}
                    </AsttDarkButton>
                  </Grid>
                  <Grid className={"text-center"} item xs={2}>
                    <AsttDarkButton
                      onClick={toggleDrawer("right", true, "edit")}
                    >
                      {t("edit")}
                    </AsttDarkButton>
                  </Grid>
                  <Grid className={"text-center"} item xs={2}>
                    <AsttLightButton
                      onClick={() => navigateToRoster(classRequestId, data)}
                    >
                      {t("classRoster")}({classRequest[0].classRosterCount})
                    </AsttLightButton>
                  </Grid>
                </Grid>
                <div>
                  <span className="orangeColor"> Created By :</span>{" "}
                  <span className="close-icn">
                    {" "}
                    {classRequest[0].createdBy}{" "}
                    {classRequest[0].createdDate !== "" &&
                      moment(classRequest[0].createdDate).format("YYYY-MM-DD")}
                  </span>
                </div>
              </div>
            )}
        </div>
      ))}

      <Drawer
        anchor={"right"}
        open={attachmentState["right"]}
        PaperProps={{
          sx: { width: "50%", backgroundColor: "#f2f2f2" },
        }}
        onClose={drawerFileAttachment("right", false)}
      >
        <FileAttachmentDrawer
          type="Classrequest"
          data={{ ...request, classRosterId: null }}
          onClose={drawerFileAttachment("right", false)}
        ></FileAttachmentDrawer>
      </Drawer>

      <Dialog
        anchor={"right"}
        open={state["right"]}
        onClose={toggleDrawer("right", false)}
        maxWidth={false}
        fullWidth
        PaperProps={{
          sx: {
            height: "100%",
            maxWidth: "md",
          },
        }}
      >
        {drawerType === "edit" && !generalStore.showProject && (
          <div>
            <DialogTitle
              id="alert-dialog-title"
              sx={{
                fontSize: "180%",
                fontWeight: "bold",
                paddingTop: "none",
              }}
            >
              <Grid container>
                <Grid item xs={8}>
                  <Typography
                    sx={{
                      fontFamily: "urbanist",
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: "#3F5765",
                    }}
                  >
                    {t("editClassRequestDetails")}
                  </Typography>
                </Grid>
                <Grid item xs={3.5}></Grid>
                <Grid item xs={0.5}>
                  <IconButton onClick={toggleDrawer("right", false, "edit")}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <Grid container>
              <Grid item xs={7}></Grid>
              <Grid item xs={1}>
                <CustomTooltip title={t("ogTitle")} arrow>
                  <Chip label="OG" sx={prepareChipStyle("OG")}></Chip>
                </CustomTooltip>
              </Grid>
              <Grid item xs={1}>
                <CustomTooltip title={t("ldTitle")} arrow>
                  <Chip label="L&D" sx={prepareChipStyle("LD")}></Chip>
                </CustomTooltip>
              </Grid>

              <Grid item xs={1.1}>
                <CustomTooltip title={t("wfmTitle")} arrow>
                  <Chip label="WFM" sx={prepareChipStyle("WFM")}></Chip>
                </CustomTooltip>
              </Grid>
              <Grid item xs={0.9}>
                <CustomTooltip title={t("taTitle")} arrow>
                  <Chip label="TA" sx={prepareChipStyle("TA")}></Chip>
                </CustomTooltip>
              </Grid>
              <Grid item xs={1}>
                <CustomTooltip title={t("opsTitle")} arrow>
                  <Chip label="OPS" sx={prepareChipStyle("OPS")}></Chip>
                </CustomTooltip>
              </Grid>
            </Grid>
          </div>
        )}
        {drawerType === "edit" && (
          <ClassRequestEdit
            onClose={toggleDrawer("right", false, "edit")}
            type={"edit"}
            classRequestDetails={classRequest[0]}
          ></ClassRequestEdit>
        )}
        {generalStore.showProject === false && (
          <div className={classes.classRequestHeader}>
            {drawerType === "view" && (
              <div className={classes.classRequestHeading}>
                {t("classRequestDetails")}
              </div>
            )}
            <div className={classes.buttonContainer}>
              {drawerType === "view" && (
                <AsttButton onClick={showEditHandler}> {t("edit")}</AsttButton>
              )}
            </div>
          </div>
        )}
        {drawerType === "view" && (
          <ClassRequest
            onClose={toggleDrawer("right", false, "edit")}
            classRequestDetails={classRequest[0]}
          ></ClassRequest>
        )}
      </Dialog>
    </div>
  );
};

export default ParentClientCard;
